import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './index.css'

// Initialize theme from localStorage or system preference ASAP to avoid flash
(function initTheme() {
  try {
    const stored = localStorage.getItem('theme') || 'light';
    const useDark = stored === 'dark';
    const root = document.documentElement;
    root.classList.toggle('dark', useDark);
    // Prevent white flash in dark mode by pre-setting background
    if (useDark) {
      document.documentElement.style.backgroundColor = '#0b1220';
      document.body.style.backgroundColor = '#0b1220';
    }
  } catch (_) {}
})();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#22c55e',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
) 